import React from 'react';
import { Link } from 'react-router-dom';
import { usePermissions } from '../../contexts/PermissionContext';

import './styles.css';

export default function ProgramCard({ program }) {
  const { permissions } = usePermissions();
  return (
    <article className="program-card" style={{ '--typeColor': '#FF6B36' }}>
      <div className="program-card__image-col">
        <figure className="program-card__image-wrapper">
          <Link to={`/events?program_id=${program.id}`}>
            <img
              src={program.image_url}
              alt={program.name}
              className="program-card__image"
            />
          </Link>
        </figure>
      </div>

      <div className="program-card__content">
        <span className="program-card__taxonomy">{program.summary}</span>
        <div className="program-card__details">
          <span className="program-card__age-detail">{program.age_groups}</span>
          <div className="program-card__date-range">
            <span className="program-card__start-date">{program.start_date}</span>
            <span className="program-card__end-date"> – {program.end_date}</span>
          </div>
        </div>
        <div className="program-card__excerpt">
          <p>{program.description}</p>
        </div>
        <div className="program-card__buttons">          
          {permissions.view_training_videos && 
              <Link to={`/events?program_id=${program.id}`} className="c-btn c-btn--small c-btn--tertiary">Curriculum</Link>
          }
          <Link to={program.learn_more} className="c-btn c-btn--small c-btn--tertiary">Learn More</Link>
        </div>
      </div>
    </article>
  );
}
